import Title from '@/components/content/title/Title';
import ForgotPasswordForm from '../components/ForgotPasswordForm';

import classes from './Auth.module.css';

const ForgotPassword = () => (
  <div className={classes.page} data-mantine-color-scheme="light">
    <div className={classes.standaloneCardColumn}>
      <div className={classes.content}>
        <Title order={1}>Password Reset</Title>
        <ForgotPasswordForm />
      </div>
    </div>
  </div>
);

export default ForgotPassword;
